<template>
  <!-- <div class="user">
      <img :src="img + userinfo.avatar" alt="" />
      声音组件 默认不显示
      <audio :id="id"></audio>
      <div class="name">{{ name }}</div>
    </div>
    <video :id="id" class="mirrorVideo" autoplay></video>
    <div class="slider">
      音量控制条
      <el-slider
        v-model="volume"
        size="small"
        @input="controlVolume"
        :disabled="isDisabled"
      />
    </div> -->

  <div class="members">
    <div class="member">
      <audio :id="id"></audio>
      <img class="imgavatar" :src="img" />
      <h2 class="member-name">{{ name }}</h2>
      <!-- <span class="member-role">{{ userinfo.sex }}</span> -->
      <video :id="'video' + id" class="mirrorVideo imgavatar" autoplay></video>
      <el-slider
        v-model="volume"
        size="small"
        @input="controlVolume"
        :disabled="isDisabled"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    socketId: {
      type: String,
      required: true
    },
    userinfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      volume: 100, // 音量初始值
      img: null
    };
  },
  computed: {
    // 若 id 为当前用户，则禁用滑动条
    isDisabled() {
      return this.id === this.socketId; // 假设 Vuex 存储用户 ID
    }
  },
  mounted() {
    this.img = process.env.VUE_APP_IMG_API + this.userinfo.avatar;
  },
  methods: {
    // 音量调整
    controlVolume() {
      const audio = document.getElementById(this.id);
      if (audio) {
        audio.volume = this.volume / 100;
      }
    }
  }
};
</script>

<style scoped>
.mirrorVideo {
  transform: scaleX(-1);
}
/* 卡片 */
.member {
  text-align: center;
  padding: 24px;
  box-sizing: border-box;
  margin-bottom: 30px;
  width: 200px;
}

.member-name {
  margin: 0;
  margin-top: 12px;
  font-weight: 600;
  font-size: 24px;
  color: #007765;
}

.member-role {
  font-style: italic;
  font-size: 18px;
}
.imgavatar {
  width: 150px;
  height: 150px;
  border-radius: 50%;
}
video {
  /* filter: blur(10px); */
}
</style>
